import React from "react";

const Svg = ({width = 210}: {width?: number} = {}) => {
  const w = 210;
  const h = 53;
  const height = (width / w) * h;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 210 53"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <rect
        x="0.5"
        y="0.5"
        width="209"
        height="52"
        rx="7.5"
        fill="url(#paint0_linear_415_115)"
        stroke="#72C1F2"
      />
      <defs>
        <linearGradient
          id="paint0_linear_415_115"
          x1="105"
          y1="0"
          x2="105"
          y2="53"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#72C1F2" />
          <stop offset="1" stopColor="#004B79" />
        </linearGradient>
      </defs>
    </svg>
  );
};
export default Svg;
